import { render } from "./ArticleManageMergedView.vue?vue&type=template&id=3066ea0f&scoped=true"
import script from "./ArticleManageMergedView.vue?vue&type=script&lang=js"
export * from "./ArticleManageMergedView.vue?vue&type=script&lang=js"

import "./ArticleManageMergedView.vue?vue&type=style&index=0&id=3066ea0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3066ea0f"]])

export default __exports__